"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var uniqid_1 = __importDefault(require("uniqid"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Button_1 = require("../../atoms/Button/Button");

var Icon_1 = require("../../atoms/Icon");

var Icon_2 = require("../../atoms/Icon/Icon");

var Looks;

(function (Looks) {
  Looks["LEFT"] = "lsg--iconlink__left";
  Looks["RIGHT"] = "lsg--iconlink__right";
  Looks["CIRCLE"] = "lsg--iconlink__circle";
  Looks["NO_ICON"] = "lsg--iconlink__noicon";
  Looks["NO_TEXT"] = "lsg--iconlink__notext";
  Looks["NO_TEXT_NO_HOVER"] = "lsg--iconlink__notexthover";
})(Looks || (Looks = {}));

exports.Looks = Looks;
var mapLookToIconSize = {
  "lsg--iconlink__left": Icon_2.Sizes.SMALL,
  "lsg--iconlink__right": Icon_2.Sizes.SMALL,
  "lsg--iconlink__circle": Icon_2.Sizes.CIRCLE,
  "lsg--iconlink__noicon": ""
};
var Colors;

(function (Colors) {
  Colors["DEFAULT"] = "";
  Colors["SECONDARY"] = "lsg--iconlink__secondary";
  Colors["DISABLED"] = "lsg--iconlink__disabled";
})(Colors || (Colors = {}));

var mapColorToIconColor = {
  "": Icon_2.Colors.DEFAULT,
  "lsg--iconlink__secondary": Icon_2.Colors.SECONDARY,
  "lsg--iconlink__disabled": Icon_2.Colors.DISABLED
};
var defaultProps = {
  look: Looks.LEFT,
  color: Colors.DEFAULT,
  iconVariant: Icon_1.Icon.Variants.OUTLINE
};

exports.IconLink = function (_a) {
  var id = _a.id,
      children = _a.children,
      iconOnly = _a.iconOnly,
      className = _a.className,
      iconName = _a.iconName,
      iconVariant = _a.iconVariant,
      iconColorProp = _a.iconColor,
      look = _a.look,
      colorProp = _a.color,
      disabled = _a.disabled,
      onClick = _a.onClick,
      buttonProps = __rest(_a, ["id", "children", "iconOnly", "className", "iconName", "iconVariant", "iconColor", "look", "color", "disabled", "onClick"]);

  var color = disabled ? Colors.DISABLED : colorProp;
  var iconColor = iconColorProp || mapColorToIconColor[color];
  var uuid = id || uniqid_1["default"]("iconlink-");
  var iconElement = look === Looks.NO_ICON ? "" : React.createElement(Icon_1.Icon, {
    className: CSSPrefix_1.lsgPre + "iconlink-svg",
    name: iconName,
    variant: iconVariant,
    color: iconColor,
    size: mapLookToIconSize[look],
    svgAttrs: {
      "aria-hidden": true
    },
    title: ""
  });

  var internalOnClick = function internalOnClick(e) {
    var elm = document.getElementById(uuid);
    elm.classList.remove(CSSPrefix_1.lsgPre + "icon__click-anchor"); // tslint:disable-next-line

    void elm.offsetWidth; // https://css-tricks.com/restart-css-animation/#article-header-id-0

    elm.classList.add(CSSPrefix_1.lsgPre + "icon__click-anchor");
    return onClick && onClick(e);
  };

  var defaultLabel = !children && utils_1.Localization.withField(utils_1.Localization.texts && utils_1.Localization.texts.lsg.component.IconLink.defaultAriaLabel, {
    label: utils_1.Localization.getIconTitle(iconName, true)
  });

  if (React.Children.count(children) === 0) {
    // tslint:disable no-console
    console.warn("Accessibility: IconLink with icon '" + iconName + "' has no alternative text."); // tslint:enable
  }

  return React.createElement(Button_1.Button, __assign({
    id: uuid,
    className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "iconlink", CSSPrefix_1.lsgPre + "icon__hover-anchor", className, CSSPrefix_1.prefixEnumClassNames(look), CSSPrefix_1.prefixEnumClassNames(color), iconOnly && CSSPrefix_1.lsgPre + "iconlink__icon-only"])
  }, buttonProps, {
    onClick: internalOnClick,
    disabled: disabled,
    look: Button_1.Button.Looks.NONE
  }), iconElement, React.createElement("span", {
    className: CSSPrefix_1.lsgPre + "iconlink-label"
  }, children || defaultLabel));
};

exports.IconLink.defaultProps = defaultProps;
exports.IconLink.Looks = Looks;
exports.IconLink.Colors = Colors;
exports.IconLink.displayName = "IconLink";